import React, { ReactElement, useState } from "react";
import moment, { Moment } from "moment-timezone";
import ScheduleListEvent from "./ScheduleListEvent";
import clsx from "clsx";
import { specialAirtime } from "@pages/dashboard/components2.0/Schedule/Schedule";
import bookIcon from "@public/images/icons/book.png";
import planeIcon from "@public/images/icons/plane.png";
import belarusFlag from "@public/images/icons/belarus.png";
import palmIcon from "@public/images/icons/palm.png";
import cubaIcon from "@public/images/icons/cuba.svg";
import paksIcon from "@public/images/icons/paks.svg";
import spaceIcon from "@public/images/icons/space.png";
import travelataIcon from "@public/images/icons/travelata.png";
import uaeIcon from "@public/images/icons/uae.png";
import { DayTags } from "./DayTags";
import shieldIcon from "@public/images/icons/shield.png";
import qaIcon from "@public/images/icons/qa.png";
import caseIcon from "@public/images/icons/case.png";

interface IProps {
  dayEndTime: Moment;
  events: any[];
  isArchived: boolean;
}

// const customClasses = new Map()
//   .set("26 августа", "schedule__list-day-header--mald")
//   .set("27 августа", "schedule__list-day-header--mald")
//   .set("30 августа", "schedule__list-day-header--sey")
//   .set("4 сентября", "schedule__list-day-header--arab-lux")
//   .set("5 сентября", "schedule__list-day-header--arab-lux")
//   .set("6 сентября", "schedule__list-day-header--arab-lux")
//   .set("9 сентября", "schedule__list-day-header--cuba")
//   .set("10 сентября", "schedule__list-day-header--bel");

const archivedClasses = new Map()
  .set(true, "schedule__list-day-header--archived")
  .set(false, "");

// const networkingClasses = new Map()
//   .set(true, "schedule__list-day-header--networking-day")
//   .set(false, "");

export interface Days {
  name?: string;
  flag?: string;
  tags?: TagItem[];
  className?: string;
}

export interface TagItem {
  tag?: string;
  tagIcon?: string;
  tagClassName?: string;
  tagIconClassName?: string;
  rounded?: boolean;
  roundedFull?: boolean;
}

export const customDays: Record<string, Days> = {
  "26 августа": {
    name: "День островов Индийского океана",
    tags: [{ tagIcon: palmIcon, rounded: true }],
  },
  "27 августа": {
    name: "SPACE TRAVEL DAY",
    tags: [
      {
        tagIcon: spaceIcon,
        rounded: true,
        tagIconClassName: "!w-full !h-full object-cover",
        tagClassName: "md:w-[89px] overflow-hidden",
      },
    ],
    className: "!bg-[#005890]",
  },
  "28 августа": {
    name: "День Республики Беларусь",
    tags: [
      {
        tagIcon: belarusFlag,
        rounded: true,
      },
    ],
  },
  "3 сентября": {
    name: "День авиакомпаний",
    tags: [{ tagIcon: planeIcon, rounded: true }],
  },
  // "2 сентября": {
  //   tags: [{ tag: "практикум", tagIcon: bookIcon, roundedFull: true }],
  // },
  "4 сентября": {
    name: "TRAVELATA DAY",
    tags: [
      {
        tagIcon: travelataIcon,
        rounded: true,
        tagIconClassName: "!w-full !h-full object-cover",
        tagClassName: "md:w-[89px] overflow-hidden",
      },
    ],
    className: "!bg-[#059BCE]",
  },
  "5 сентября": {
    name: "День Кубы",
    tags: [
      {
        tagIcon: cubaIcon,
        rounded: true,
        tagIconClassName: "!w-9 !h-4 object-cover",
      },
    ],
  },
  "8 сентября": {
    name: "День ОАЭ",
    tags: [{ tagIcon: uaeIcon, rounded: true }],
  },
  "9 сентября": {
    name: "День ОАЭ",
    tags: [{ tagIcon: uaeIcon, rounded: true }],
  },
  "10 сентября": {
    name: "День ОАЭ",
    tags: [{ tagIcon: uaeIcon, rounded: true }],
  },
  "11 сентября": {
    name: "День технологий для туризма",
    tags: [{ tagIcon: caseIcon, rounded: true }],
  },
  "12 сентября": {
    name: "PAKS DAY",
    tags: [
      {
        tagIcon: paksIcon,
        rounded: true,
        tagIconClassName: "!w-auto !h-full object-cover",
        tagClassName: "md:w-[89px] overflow-hidden",
      },
    ],
    className: "!bg-[#E16722]",
  },
  // "16 сентября": {
  //   name: "День Катара",
  //   tags: [{ tagIcon: qaIcon, rounded: true }],
  // },
  //"17 сентября": {
  //  name: "День страхования",
  //  tags: [{ tagIcon: shieldIcon, rounded: true }],
  //},
};

const networkingText = new Map()
  .set(true, " — День Нетворкинга")
  .set(false, "");

const ScheduleListDay = ({
  dayEndTime,
  events,
  isArchived,
}: IProps): ReactElement => {
  const [isShowed, setIsShowed] = useState(!isArchived);

  if (events.length < 1) {
    return <></>;
  }

  const formattedEventDate = moment(events[0]?.date)
    .tz("Europe/Moscow")
    .format("D MMMM");

  const formattedEventDateShort = moment(events[0]?.date)
    .locale("ru")
    .tz("Europe/Moscow")
    .format("D MMM");

  const isNetworkingDay = !!events.find((item) => item.networkingDay);

  // const currentClass = customClasses.get(formattedEventDate)
  //   ? customClasses.get(formattedEventDate)
  //   : networkingClasses.get(isNetworkingDay)
  //   ? networkingClasses.get(isNetworkingDay)
  //   : "";

  const currentCustomDay =
    customDays[formattedEventDate] || networkingText.get(isNetworkingDay) || "";

  const isSpecialAirtime = specialAirtime.includes(formattedEventDate);

  return (
    <div
      id={"date_" + moment(dayEndTime).tz("Europe/Moscow").format("DDMM")}
      className={`schedule__list-day ${
        !isShowed ? "schedule__list-day--hidden" : ""
      }`}
    >
      <div
        className={clsx(
          "schedule__list-day-header",
          archivedClasses.get(isArchived),
          currentCustomDay.className
        )}
        onClick={() => setIsShowed(!isShowed)}
      >
        <div className="schedule__list-day-date-wrapper">
          <div className="schedule__list-day-date">
            {isArchived && (
              <>
                <span>Архив</span>
                <hr />
              </>
            )}
            {!isArchived && <span>{formattedEventDate}</span>}
            {isArchived && (
              <>
                <span className="md:hidden">{formattedEventDateShort}</span>
                <span className="hidden md:block">{formattedEventDate}</span>
              </>
            )}
            <hr />
            <span className="shedule__list-day-week">
              {moment(events[0]?.date).tz("Europe/Moscow").format("dddd")}
            </span>
            <span className="shedule__list-day-week-short md:hidden">
              {moment(events[0]?.date)
                .tz("Europe/Moscow")
                .format("ddd")
                .toUpperCase()}
            </span>
            {currentCustomDay && currentCustomDay.name && (
              <>
                <hr className="shedule__list-day-date-name" />
                <span className="shedule__list-day-date-name">
                  {currentCustomDay.name}
                </span>
              </>
            )}
          </div>
          {(currentCustomDay.flag ||
            isSpecialAirtime ||
            !!currentCustomDay?.tags?.length) && (
            <div
              className={clsx("flex gap-3", {
                "hidden md:flex gap-3": isArchived,
              })}
            >
              {!!currentCustomDay?.tags?.length && (
                <DayTags tags={currentCustomDay.tags} />
              )}
              {currentCustomDay.flag && (
                <div className="flex">
                  <img
                    height={30}
                    src={require(`@public/images/flags/${currentCustomDay.flag}`)}
                    alt="Флаг"
                  />
                </div>
              )}
              {isSpecialAirtime && (
                <div className="flex rounded bg-white justify-center items-center py-[6px] gap-2 px-[10px]">
                  <p className="hidden md:flex text-14 font-bold text-black">
                    Спецэфир
                  </p>
                  <img
                    className="shrink-0"
                    width={18}
                    height={18}
                    src={require("@public/images/fire.png")}
                    alt="Огонь"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className={`schedule__list-day-body`}>
        {events.map((event: any, index: number) => {
          return event.networkingDay ? (
            <ScheduleListEvent key={index} event={event} networkingDay={true} />
          ) : (
            <ScheduleListEvent
              key={index}
              event={event}
              networkingDay={false}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ScheduleListDay;
